<script lang="ts" setup>
import { computed, ref } from "vue";
import { useReply } from "@/stores/reply";
import { useMate } from "@/stores/mate";
import { useGlobalUser } from "@/stores/globalUser";
import { Reply } from "@/types/entity";
const props = defineProps<{
  reply?: Reply;
  topN?: number;
  ghost?: boolean;
  group?: boolean;
}>();
const userStore = useGlobalUser();
const replyStore = useReply();
const mate = useMate();
const loadingId = ref(0);
const sortedReactionList = computed<Reply["interactivityEmoji"]>(() => {
  if (!props.reply?.interactivityEmoji) {
    return [];
  } else {
    const list = props.reply.interactivityEmoji
      ?.filter((item) => item.amount > 0)
      .sort((a, b) => b.amount - a.amount);
    return props.topN ? list.slice(0, props.topN) : list;
  }
});
const currentMateVotedEmojiIdSet = computed<Set<number>>(() => {
  if (!props.reply?.emojiVotezz || props.reply.emojiVotezz.length === 0) {
    return new Set();
  } else {
    return new Set(
      props.reply.emojiVotezz
        ?.filter((item) => item.mateId === mate.currentMate?.id)
        .map((item) => item.emojiId)
    );
  }
});
const onClick = async (e: UIEvent, emojiId: number) => {
  e.stopPropagation();
  if (!userStore.isLogin) {
    userStore.loginModal.show = true;
    return;
  }
  if (!mate.currentMate) {
    return;
  }
  loadingId.value = emojiId;
  try {
    await replyStore.vote(emojiId, props.reply!.id!);
  } finally {
    loadingId.value = 0;
  }
};
const getBtnClass = (item: { id?: number }) => {
  let classList: string[] = [];

  if (props.ghost) {
    if (currentMateVotedEmojiIdSet.value.has(item.id!)) {
      classList.push("border");
    }

    if (!currentMateVotedEmojiIdSet.value.has(item.id!)) {
      classList.push("btn");
    }
  } else {
    if (!currentMateVotedEmojiIdSet.value.has(item.id!)) {
      classList.push("btn");
    }

    if (currentMateVotedEmojiIdSet.value.has(item.id!)) {
      classList.push("border btn-primary");
    }
  }

  return classList;
};
</script>
<template>
  <div
    v-if="reply?.interactivityEmoji && reply?.interactivityEmoji.length > 0"
    :class="{
      'gap-1': !group,
      join: group,
    }"
    class="flex flex-wrap"
  >
    <button
      v-for="item in sortedReactionList"
      :key="item.id"
      :disabled="loadingId === item.id"
      :class="[
        'btn btn-xs font-bold rounded',
        group && 'join-item',
        ...getBtnClass(item),
      ]"
      @click="onClick($event, item.id!)"
    >
      <span class="noto-color-emoji-regular">{{ item.content }}</span>
      {{ item.amount }}
      <span v-show="loadingId === item.id" class="loading-xs loading"></span>
    </button>
  </div>
</template>
